
// check whether this project is a builder
let isBuilder = false;
export const initializeBuilderMode = () => {
  isBuilder = true;
};
export const isBuilderMode = () => isBuilder;